import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { reportsLoader } from './reports-loader';

export const reportsRoutes: RouteObject = {
  loader: reportsLoader,
  children: [
    {
      path: '/reports',
      lazy: lazyComponent(
        () => import('@pages/client/report/reports-page'),
        'ReportsPage',
      ),
    },
  ],
};
